import {RouteDefinition} from '../../../routes';
import {SettingsLoginScreen} from './SettingsLoginScreen';

export const SettingsLoginRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/login',
        component: SettingsLoginScreen,
    },
];
